/* index.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./index.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
var animationNameStyles = null;
var loadingSkeletonStyle = null;
export var LoadingSkeleton = function LoadingSkeleton(_ref) {
  var testId = _ref.testId,
    width = _ref.width,
    height = _ref.height;
  return /*#__PURE__*/React.createElement("span", {
    "data-testid": testId,
    className: ax(["_2rkoyh40 _uiztglyw _bfhk178v _1itkx3i8 _12vemgnk _1lrw6rms _1e0c1o8l _5sag9cwz _1o51q7pw _tip812c5 _j7hqqkar _1pglp3kn"]),
    style: {
      width: width,
      height: height,
      "--_16116mi": ix("linear-gradient( to right, transparent 0%, ".concat("var(--ds-skeleton, #edeef1)", " 20%, transparent 40%, transparent 100% )"))
    }
  });
};